export default __webpack_public_path__ + "static/media/2.155a6620.png";